import { CircleNotchIcon, MagnifyingGlassIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useAdminUsers } from "@/lib/api";

import { UserTable } from "./user-table";

export function AdminUsersPage() {
  const usersQuery = useAdminUsers();
  const [search, setSearch] = useState("");

  const users = usersQuery.data ?? [];
  const filtered = users.filter((u) => {
    const q = search.toLowerCase();
    return (
      u.email.toLowerCase().includes(q) ||
      (u.first_name ?? "").toLowerCase().includes(q) ||
      (u.last_name ?? "").toLowerCase().includes(q)
    );
  });

  return (
    <div className="bg-background min-h-screen">
      <header className="border-border flex items-center justify-between border-b px-6 py-4">
        <h1 className="t-heading text-foreground">User Management</h1>
        <div className="flex items-center gap-2">
          <Link to="/admin/activity">
            <Button variant="ghost">Activity</Button>
          </Link>
          <Link to="/cockpit">
            <Button variant="outline">Back</Button>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">
        {usersQuery.isLoading ? (
          <Card>
            <CardContent className="flex justify-center py-12">
              <CircleNotchIcon className="text-muted h-6 w-6 animate-spin" />
            </CardContent>
          </Card>
        ) : usersQuery.isError ? (
          <Card>
            <CardContent className="py-8 text-center">
              <p className="text-muted text-sm">
                Could not load users. Please{" "}
                <button
                  type="button"
                  onClick={() => void usersQuery.refetch()}
                  className="underline"
                >
                  try again
                </button>{" "}
                or{" "}
                <Link to="/cockpit" className="underline">
                  go back
                </Link>
                .
              </p>
            </CardContent>
          </Card>
        ) : (
          <>
            <div className="mb-6 flex items-center gap-4">
              <div className="relative flex-1">
                <MagnifyingGlassIcon className="text-muted absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
                <Input
                  placeholder="Search users..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>
            <UserTable users={filtered} />
          </>
        )}
      </main>
    </div>
  );
}
